import LazyWidgetController from "./lazy_widget_controller"

// Stimulus controller wrapping Tagify for tag-style text inputs.
//
// Tagify wraps the <input> in a <tags> element on init (re-parenting it), so the
// re-parent guard + Turbo-cache-safe teardown in LazyWidgetController are what
// keep it from looping / double-initialising. This subclass only supplies
// load()/build().
//
// Reads the SAME data-* attributes/classes the legacy `$('.tagify-field').each`
// did, so behaviour is identical:
//   - data-tagify-whitelist / data-whitelist  -> whitelist (comma-split if string)
//   - data-tagify-enforce-whitelist           -> enforceWhitelist
//   - data-tagify-edit-tags                    -> editTags
//   - data-tagify-skip-invalid                 -> skipInvalid
//   - .tagify-mode-select                      -> mode: 'select'
//
// Usage in views (rendered by AppFormBuilder app_tags):
//   <input type="text" data-controller="tags" class="tagify-field"
//          data-tagify-whitelist="ruby,rails,js">
//
export default class extends LazyWidgetController {
  async load() {
    return (await import("@yaireo/tagify")).default
  }

  build(Tagify) {
    const el = this.element

    // Tagify reads dataset values as strings; mirror the jQuery .data() coercion
    // the original relied on (arrays/strings as authored in markup).
    var rawWhitelist = el.dataset.tagifyWhitelist || el.dataset.whitelist || []
    if (typeof rawWhitelist === 'string') {
      rawWhitelist = rawWhitelist
        .split(',')
        .map(function (s) { return (s || '').trim() })
        .filter(function (s) { return s.length > 0 })
    }

    var options = {
      whitelist: rawWhitelist,
      dropdown: {
        enabled: 0,
        closeOnSelect: false
      },
      enforceWhitelist: this.boolDataset(el.dataset.tagifyEnforceWhitelist) || false,
      editTags: this.boolDataset(el.dataset.tagifyEditTags) || true,
      skipInvalid: this.boolDataset(el.dataset.tagifySkipInvalid) || true,
      originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join(','),
    }

    if (el.classList.contains('tagify-mode-select')) {
      options.mode = 'select'
      options.dropdown = { closeOnSelect: true }
    }

    return new Tagify(el, options)
  }

  // destroy() inherited from LazyWidgetController: Tagify instance has .destroy().

  // jQuery's .data() auto-parses "true"/"false"/numbers; replicate the bits we
  // depend on (booleans) so attribute values keep working as before.
  boolDataset(value) {
    if (value === undefined || value === null) return undefined
    if (value === 'true') return true
    if (value === 'false') return false
    return value
  }
}
